// Maps server responses from content functions to a stable error kind,
// so the UI can show a precise message and the right action.
export type GenerationErrorKind =
  | "daily_limit"
  | "guest_limit"
  | "rate_limit"
  | "content_limit"
  | "pro_required"
  | "quota_unavailable"
  | "session_expired"
  | "generic";

export class GenerationError extends Error {
  constructor(public kind: GenerationErrorKind, message?: string) {
    super(message || kind);
    this.name = "GenerationError";
  }
}

export function classifyGenerationResponse(
  status: number,
  body: { code?: string; error?: string } | null,
  isGuest: boolean,
): GenerationErrorKind {
  const code = body?.code;
  const msg = (body?.error || "").toLowerCase();
  if (code === "daily_limit_reached") return "daily_limit";
  if (code === "quota_check_unavailable" || status === 503) return "quota_unavailable";
  if (code === "pro_required" || status === 402) return "pro_required";
  if (status === 401) return "session_expired";
  if (status === 429) {
    if (msg.includes("daily content")) return "content_limit";
    return isGuest ? "guest_limit" : "rate_limit";
  }
  return "generic";
}

/** Retrying immediately cannot help for these kinds. */
export function isRetryable(kind: GenerationErrorKind): boolean {
  return kind === "generic" || kind === "quota_unavailable";
}
